import React from 'react';
import {
    Box, Typography, TextField
} from '@mui/material';

interface OtherEventFormProps {
    description: string;
    setDescription: (value: string) => void;
    isViewMode: boolean;
}

const OtherEventForm: React.FC<OtherEventFormProps> = ({
    description,
    setDescription,
    isViewMode
}) => {
    return (
        <Box sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 2,
            mt: 3,
            backgroundColor: '#f8f9fa'
        }}>
            <Typography variant="subtitle1" sx={{ fontSize: '0.9rem', fontWeight: 'bold', mb: 2 }}>
                OUTRO EVENTO
            </Typography>

            <TextField
                fullWidth
                label="Descrição do Evento *"
                multiline
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                variant="outlined"
                size="small"
                margin="dense"
                InputLabelProps={{ style: { fontSize: '0.85rem' } }}
                InputProps={{ style: { fontSize: '0.85rem' } }}
                placeholder="Descreva o evento que deseja registrar..."
                disabled={isViewMode}
            />
        </Box>
    );
};

export default OtherEventForm;
